export const ticketFromResponse = (data) => {
  if (Array.isArray(data)) return data[0];
  if (data?.ticket && typeof data.ticket === "object") return data.ticket;
  return data && typeof data === "object" ? data : undefined;
};

export const lotteryTicketLine = (line = {}) => {
  const numbers = Array.isArray(line.numbers) ? line.numbers : [];
  const type = numbers.length === 1 ? "Q" : numbers.length === 2 ? "P" : numbers.length === 3 ? "T" : "";
  return {
    label: type ? `${type} ${numbers.join(" ")}` : String(line.bet || line.dog || ""),
    amount: Number(line.betted ?? line.amount ?? 0),
  };
};

export const ticketPointName = (ticket = {}) =>
  String(ticket.pv || ticket.point?.name || ticket.point || "");

export const ticketRunCode = (ticket = {}) =>
  String(ticket.codeRun || ticket.run?.code || ticket.run?.num || ticket.run || "");
